import { IAllocationDisplayItem } from '../../../../components/video/ManageMinutesDrawer/interfaces';

type AllocationId = string;

export type AllocationItemByIdMap = Record<AllocationId, IAllocationItemStore>;

/** @description 2025-08-07 */
export type YYYYMMDD = string;
/** @description 2025-08-19T16:15:11.721Z */
export type ISO8601 = string;

export type AllocationItemType = 'term' | 'additionalMinutes';

export enum FetchingStatus {
  Failed = 'failed',
  Idle = 'idle',
  Loading = 'loading',
  Succeeded = 'succeeded'
}

export interface IAllocationItem {
  allocatedSeconds: number;
  createdAt: ISO8601;
  termEndDate?: YYYYMMDD;
  termStartDate: YYYYMMDD;
  type: AllocationItemType;
  updatedAt: ISO8601;
}

export interface IAllocationItemStore extends IAllocationItem {
  id: string;
}

export interface ICreateAllocationItemStore {
  id: string;
}

export type ICreateAllocationItemResponse = string;

export interface IVideoManagementState {
  addMinutesToCurrentTermStatus: FetchingStatus;
  creatingNewTermStatus: FetchingStatus;
  deleteTermStatus: FetchingStatus;
  fetchingManagementListStatus: FetchingStatus;
  idsList: string[];
  isModalOpen: boolean;
  map: AllocationItemByIdMap;
  updateTermStatus: FetchingStatus;
}

export interface ICreateTermBodyPayload {
  termStartDate: YYYYMMDD;
  allocatedSeconds: number;
}

export interface ICreateTermPayload extends ICreateTermBodyPayload {
  accountId: string;
}

export interface IGetAllocationItemResponse extends IAllocationItem {
  _id: string;
  companyId: string;
}

export interface IFetchAllocationItemsPayload {
  accountId: string;
}

export interface IUpdateTermParam {
  _id: string;
  allocatedSeconds: number;
  termStartDate: YYYYMMDD | undefined; // Required only when the term type is "term"
}

export interface IUpdateTermThunkPayload extends IUpdateTermParam {
  accountId: string;
}

export type IUpdateTermApiPayload = IUpdateTermParam;

export interface IAddTimeToCurrentTermParams {
  allocatedSeconds: number;
}

export interface IAddTimeToCurrentTermThunkPayload extends IAddTimeToCurrentTermParams {
  accountId: string;
}

export type IAddTimeToCurrentTermApiPayload = IAddTimeToCurrentTermParams;

export interface IAddTimeToCurrentTermThunkResponse {
  id: string;
}

export interface IAddTimeToCurrentTermApiResponse {
  _id: string;
}

export interface IRemoveTermThunkPayload {
  id: string;
  accountId: string;
}

export interface IRemoveTermApiPayload {
  _id: string;
}

export interface ITermStartData {
  index: number;
  item: IAllocationDisplayItem;
}
